<template>
  <div class="h-full">
    <div class="">
      <div class="justify-between items-center mt-2 lg:mt-0 md:p-3 md:flex">
        <div>
          <div class="text-2xl text-[#09518C]">Payment History</div>
          <div class="text-sm text-gray-500">
            A Description of the Payment History Details
          </div>
        </div>
        <div class="flex flex-col justify-end mt-2 md:mt-0 md:flex-row">
          <div
            @click="downloadFile()"
            class="bg-[#8DC63F] text-white hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] border transition-colors duration-300 rounded-lg px-3 py-1.5 cursor-pointer"
          >
            Export to Excel
          </div>
        </div>
      </div>

      <div class="overflow-x-auto mt-3 md:mt-0">
        <TableComponent
          :columns="tableColumns"
          :data="displayedHistoryDetails"
        />
        <div
          class="text-center text-[#F58220] my-3"
          v-if="paymentData.length === 0 && !loading"
        >
          No Transaction Available for the specified period
        </div>
        <div
          role="status"
          class="flex justify-center w-full my-6"
          v-if="loading === true"
        >
          <LoadingSpinner />
        </div>
        <pagination
          v-model="page"
          :records="paymentData.length"
          :per-page="50"
        />
      </div>
      <div class="text-sm text-gray-600"></div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { computed, onMounted, ref } from "@vue/runtime-core";
import exportFromJSON from "export-from-json";
import { toolkitAxios } from "@/env";
import TableComponent from "@/components/TableComponent.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
export default {
  components: {
    TableComponent,
    LoadingSpinner,
  },
  setup() {
    const route = useRoute();
    const paymentData = ref("");
    const loading = ref(false);
    const page = ref(1);
    const perPage = ref(20);
    const tableColumns = ref([
      { key: "name", label: "Staff", className: "px-2 py-2" },
      { key: "pin", label: "PIN", className: "px-2 py-2" },
      {
        key: "employer",
        label: "Employer Contribution",
        className: "px-2 py-2",
      },
      {
        key: "employee",
        label: "Employee Contribution",
        className: "px-2 py-2",
      },
      {
        key: "status",
        label: "Status",
        className: "px-2 py-2",
        classCondition: (item) => ({
          "text-green-500":
            item.status === "unprocessed"
              ? "text-green-500 cursor-pointer"
              : "",
        }),
      },
    ]);

    const downloadFile = () => {
      const data = paymentData.value;
      const fileName = "payment-history-details";
      const exportType = exportFromJSON.types.csv;

      if (data) exportFromJSON({ data, fileName, exportType });
    };

    const displayedHistoryDetails = computed(() => {
      const startIndex = perPage.value * (page.value - 1);
      const endIndex = startIndex + perPage.value;
      return paymentData.value.slice(startIndex, endIndex);
    });

    const getPaymentDetails = async () => {
      loading.value = true;

      toolkitAxios
        .post(`employer/remittancehistory/${route.params.id}/details`)
        .then((response) => {
          paymentData.value = response.data.data;
        });

      loading.value = false;
    };

    onMounted(() => {
      getPaymentDetails();
    });

    return {
      route,
      paymentData,
      loading,
      page,
      perPage,
      displayedHistoryDetails,
      downloadFile,
      tableColumns,
    };
  },
};
</script>

<style scoped>
tbody tr {
  background-color: #fff;
  border-bottom: 1px solid #e5e7eb;
}
</style>

<style></style>
